
import {
    AddRegular,
    AddFilled,
    ArrowClockwiseFilled,
    ArrowClockwiseRegular,
    FilterDismissRegular,
    SendRegular,
    DismissRegular,
    EyeRegular,
    ChevronDoubleLeftRegular,
    ChevronDoubleRightRegular,
    iconFilledClassName,
    iconRegularClassName,
    bundleIcon,
    CalendarLtrRegular,
    PeopleQueueRegular,
    NavigationRegular,
    PeopleQueueFilled,
    Search24Filled,
    TimerFilled,
    TimerRegular,
    EditRegular,
    DocumentBulletListOffFilled,
    AppsListFilled,
    AppsListRegular,
    InfoRegular,
    DeleteRegular,
    EditFilled,
    DeleteFilled,
    HistoryRegular,
    DocumentSaveFilled,
    DocumentOnePageRegular,
    ArrowMaximizeFilled,
    ArrowMaximizeRegular,
    ArrowMinimizeRegular,
    ArrowHookDownLeftFilled,
    ArrowHookDownLeftRegular,
    CheckmarkFilled,
    ArrowLeftFilled,
    ArrowLeftRegular,
    CheckmarkRegular,
    FilterFilled,
    BedRegular,
    BedFilled,
    ArrowSortDownLinesFilled,
    ArrowSortDownLinesRegular,
    LockClosedFilled,
    LockClosedRegular,
    PersonAddFilled,
    PersonAddRegular,
    DocumentArrowUpFilled,
    DocumentArrowUpRegular,
    DocumentArrowDownFilled,
    DocumentArrowDownRegular,
    CalendarCancelFilled,
    CalendarCancelRegular,
    CalendarCheckmarkFilled,
    CalendarCheckmarkRegular,
    BuildingRegular,
    BuildingHomeRegular,
    CubeMultipleRegular,
    DocumentCubeRegular,
    ClipboardTaskListLtrFilled,
    ClipboardTaskListLtrRegular,
    DocumentAddRegular,
    DocumentAddFilled,
    CalendarEditFilled,
    CalendarEditRegular,
    EyeOffFilled,
    EyeOffRegular,
    ArrowDownloadRegular,
    GanttChartRegular,
    GanttChartFilled,
    PeopleTeamFilled,
    PeopleTeamRegular,
    MoneyCalculatorFilled,
    BuildingRetailMoneyRegular,
    PlayFilled,
    PlayRegular,
    DocumentCheckmarkFilled,
    DocumentCheckmarkRegular,
    SettingsFilled,
    SettingsRegular
} from "@fluentui/react-icons";
import { makeStyles, tokens } from "@fluentui/react-components";
import React from "react";
export interface IIcon {
    key: string;
    text: string;
    icon: React.ReactNode; 
}
const useIconStyles = makeStyles({
    icon: {
        ":hover": {
            [`& .${iconFilledClassName}`]: {
                display: "none",
            },
            [`& .${iconRegularClassName}`]: {
                display: "inline",
            },
        },
    },
    color: {
        ":hover": {
            [`& .${iconFilledClassName}`]: {
                display: "none",
                color: "#ffffff",
            },
            [`& .${iconRegularClassName}`]: {
                display: "inline",
                color: "#ffffff",
            },
        },
        ":root": {
            color: "#fff",
        },
    },
});

const iconStyleProps: any = {
    primaryFill: "#1267b4",
    //primaryFill: tokens.colorBrandBackground2Hover,
    className: "iconClass",
};
const iconStyleFooter: any = {
    primaryFill: "#ffffff",
};

export const useIconsCatalogo = () => {

    const styles = useIconStyles();

    const Visitas = bundleIcon(PeopleQueueFilled, PeopleQueueRegular);
    const Temporales = bundleIcon(TimerFilled, TimerRegular);
    const AgregarPersona = bundleIcon(PersonAddFilled, PersonAddRegular)
    const Eliminar = bundleIcon(DeleteFilled, DeleteRegular);
    const Editar = bundleIcon(EditFilled, EditRegular);
    const UploadFile = bundleIcon(DocumentArrowUpFilled, DocumentArrowUpRegular);
    const DownloadFile = bundleIcon(DocumentArrowDownFilled, DocumentArrowDownRegular);
    const Regresar = bundleIcon(ArrowLeftFilled, ArrowLeftRegular);
    const Bloquear = bundleIcon(LockClosedFilled, LockClosedRegular);
    const AnularReserva = bundleIcon(CalendarCancelFilled, CalendarCancelRegular);
    const FinalizarOcupabilidad = bundleIcon(CalendarCheckmarkFilled, CalendarCheckmarkRegular);
    const DiagonalArrowHover = bundleIcon(
        ArrowMaximizeFilled,
        ArrowMaximizeRegular
    );
    const Lista = bundleIcon(AppsListFilled, AppsListRegular)
    const Cama = bundleIcon(BedFilled, BedRegular)
    const AgregarHover = bundleIcon(AddFilled, AddRegular);
    const RefrescarHover = bundleIcon(
        ArrowClockwiseFilled,
        ArrowClockwiseRegular
    );
    const ArrowDownHookLeftHover = bundleIcon(
        ArrowHookDownLeftFilled,
        ArrowHookDownLeftRegular
    );
    const Backlog = bundleIcon(ClipboardTaskListLtrFilled, ClipboardTaskListLtrRegular);
    const CheckmarkRegularHover = bundleIcon(CheckmarkFilled, CheckmarkRegular);
    const DocumentacionRegular = bundleIcon(DocumentAddFilled, DocumentAddRegular)
    const DescargarFiltro = bundleIcon(ArrowSortDownLinesFilled, ArrowSortDownLinesRegular);
    const ReunionRegular = bundleIcon(CalendarEditFilled, CalendarEditRegular);
    const OjoRegular = bundleIcon(EyeOffFilled, EyeOffRegular);
    const FinanzasRegular = bundleIcon(MoneyCalculatorFilled, BuildingRetailMoneyRegular)
    const Check = bundleIcon(ClipboardTaskListLtrFilled, ClipboardTaskListLtrRegular);
    const GanntRegular = bundleIcon(GanttChartFilled, GanttChartRegular)
    const UsuarioRegular = bundleIcon(PeopleTeamFilled, PeopleTeamRegular)
    const IniciarRegular = bundleIcon(PlayFilled, PlayRegular);
    const DocumentCheckmark = bundleIcon(DocumentCheckmarkFilled, DocumentCheckmarkRegular
    );
    const ConfiguracionRegular = bundleIcon(SettingsFilled, SettingsRegular)


    const DownloadSubmit = bundleIcon(
        ArrowDownloadRegular,
        ArrowDownloadRegular
    );
    const iconos: IIcon[] = [
        {
            key: "ConfiguracionRegular",
            text: "ConfiguracionRegular",
            icon: (
                <ConfiguracionRegular
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            )
        },
        {
            key: "DocumentCheckmark",
            text: "DocumentCheckmark",
            icon: (
                <DocumentCheckmark
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            )
        },
        {
            key: "DownloadSubmit",
            text: "DownloadSubmit",
            icon: (
                <DownloadSubmit
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            )
        },
        {
            key: "IniciarRegular",
            text: "IniciarRegular",
            icon: (
                <IniciarRegular
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            )
        },
        {
            key: "FinanzasRegular",
            text: "FinanzasRegular",
            icon: (
                <FinanzasRegular
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            )
        },
        {
            key: "UsuarioRegular",
            text: "UsuarioRegular",
            icon: (
                <UsuarioRegular
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            )
        }, {
            key: "GanntRegular",
            text: "GanntRegular",
            icon: (
                <GanntRegular
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            )
        },
        {
            key: "OjoRegular",
            text: "OjoRegular",
            icon: (
                <OjoRegular
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            )
        },
        {
            key: "ReunionRegular",
            text: "ReunionRegular",
            icon: (
                <ReunionRegular
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            )
        },
        {
            key: "DocumentacionRegular",
            text: "DocumentacionRegular",
            icon: (
                <DocumentacionRegular
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            )
        },
        {
            key: "Backlog",
            text: "Backlog",
            icon: (
                <Backlog
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            )
        },
        {
            key: "DocumentoCuboRegular",
            text: "DocumentoCuboRegular",
            icon: (
                <DocumentCubeRegular
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            )
        },
        {
            key: "CamaRegular",
            text: "CamaRegular",
            icon: (
                <BedRegular
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            )
        },
        {
            key: "HotelRegular",
            text: "HotelRegular",
            icon: (
                <BuildingRegular
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            )
        },
        {
            key: "HotelCasaRegular",
            text: "HotelCasaRegular",
            icon: (
                <BuildingHomeRegular
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            )
        },
        {
            key: "CuboMultipleRegular",
            text: "CuboMultipleRegular",
            icon: (
                <CubeMultipleRegular
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            )
        },
        {
            key: "DescargarFooter",
            text: "DescargarFooter",
            icon: (
                <ArrowDownloadRegular
                    {...iconStyleFooter}
                    style={{ fontSize: 24 }}
                />
            ),
        },
        {
            key: "Buscar",
            text: "Buscar",
            icon: (
                <Search24Filled {...iconStyleProps} style={{ fontSize: 24 }} />
            ),
        },
        {
            key: "Visitas",
            text: "Visitas",
            icon: <Visitas {...iconStyleProps} style={{ fontSize: 24 }} />,
        },
        {
            key: "Temporales",
            text: "Temporales",
            icon: <Temporales {...iconStyleProps} style={{ fontSize: 24 }} />,
        },
        {
            key: "RefrescarFooter",
            text: "RefrescarFooter",
            icon: (
                <FilterDismissRegular
                    {...iconStyleFooter}
                    style={{ fontSize: 24 }}
                />
            ),
        },
        {
            key: "EnviarFooter",
            text: "EnviarFooter",
            icon: <SendRegular {...iconStyleFooter} style={{ fontSize: 24 }} />,
        },
        {
            key: "NavigationRegular",
            text: "Detalle",
            icon: (
                <NavigationRegular
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            ),
        },
        {
            key: "CancelarFooter",
            text: "CancelarFooter",
            icon: (
                <DismissRegular {...iconStyleFooter} style={{ fontSize: 24 }} />
            ),
        },
        {
            key: "Refrescar",
            text: "Refrescar",
            icon: (
                <ArrowClockwiseRegular
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            ),
        },
        {
            key: "AnularReserva",
            text: "AnularReserva",
            icon: (
                <AnularReserva
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            ),
        },
        {
            key: "finalizarOcupabilidad",
            text: "finalizarOcupabilidad",
            icon: (
                <FinalizarOcupabilidad
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            ),
        },
        {
            key: "bloquear",
            text: "bloquear",
            icon: (
                <Bloquear {...iconStyleProps} style={{ fontSize: 24 }} />
            ),
        },
        {
            key: "UploadFile",
            text: "UploadFile",
            icon: (
                <UploadFile {...iconStyleProps} style={{ fontSize: 48 }} />
            ),
        },
        {
            key: "DownloadFile",
            text: "DownloadFile",
            icon: (
                <DownloadFile {...iconStyleProps} style={{ fontSize: 24 }} />
            ),
        },
        {
            key: "Refrescar",
            text: "Refrescar",
            icon: (
                <RefrescarHover {...iconStyleProps} style={{ fontSize: 24 }} />
            ),
        },
        {
            key: "CalendarLtrRegular",
            text: "Calendario",
            icon: (
                <CalendarLtrRegular
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            ),
        },
        {
            key: "Regresar",
            text: "Regresar",
            icon: <Regresar {...iconStyleProps} fontSize={{ fontSize: 24 }} />,
        },
        {
            key: "Cama",
            text: "Cama",
            icon: <Cama {...iconStyleProps} fontSize={{ fontSize: 24 }} />,
        },
        {
            key: "Agregar",
            text: "Agregar",
            icon: <AddRegular {...iconStyleProps} style={{ fontSize: 24 }} />,
        },
        {
            key: "AgregarHover",
            text: "AgregarHover",
            icon: <AgregarHover {...iconStyleProps} style={{ fontSize: 24 }} />,
        },
        {
            key: "EyeRegular",
            text: "Visualizar",
            icon: <EyeRegular {...iconStyleProps} />,
        },
        {
            key: "ChevronDoubleLeftRegular",
            text: "FlechasIzquierda",
            icon: (
                <ChevronDoubleLeftRegular
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            ),
        },
        {
            key: "ChevronDoubleRightRegular",
            text: "FlechasDerecha",
            icon: (
                <ChevronDoubleRightRegular
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            ),
        },
        {
            key: "Eliminar",
            text: "Eliminar",
            icon: <Eliminar {...iconStyleProps} style={{ fontSize: 24 }} />,
        },
        {
            key: "Editar",
            text: "Editar",
            icon: <Editar {...iconStyleProps} style={{ fontSize: 24 }} />,
        },
        {
            key: "EditRegularEditRegular",
            text: "Editar",
            icon: <EditRegular {...iconStyleProps} style={{ fontSize: 24 }} />,
        },
        {
            key: "DocumentBulletListOffFilled",
            text: "EliminatDocumento",
            icon: (
                <DocumentBulletListOffFilled
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            ),
        },
        {
            key: "Eliminar",
            text: "Eliminar",
            icon: (
                <DeleteRegular {...iconStyleProps} style={{ fontSize: 24 }} />
            ),
        },
        {
            key: "AppsListFilled",
            text: "Detalle",
            icon: (
                <AppsListFilled {...iconStyleProps} style={{ fontSize: 24 }} />
            ),
        },
        {
            key: "AppsListFilled",
            text: "Lista",
            icon: (
                <Lista {...iconStyleProps} style={{ fontSize: 24 }} />
            ),
        },
        {
            key: "InfoRegular",
            text: "Info",
            icon: <InfoRegular {...iconStyleProps} style={{ fontSize: 24 }} />,
        },
        {
            key: "HistoryRegular",
            text: "Historial",
            icon: <HistoryRegular {...iconStyleProps} />,
        },
        {
            key: "DocumentSaveFilled",
            text: "Documento",
            icon: (
                <DocumentSaveFilled
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            ),
        },
        {
            key: "DocumentOnePageRegular",
            text: "Documento2",
            icon: (
                <DocumentOnePageRegular
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            ),
        },
        {
            key: "DiagonalArrow",
            text: "DiagonalArrow",
            icon: <ArrowMaximizeRegular {...iconStyleProps} />,
        },
        {
            key: "OtherDiagonalArrow",
            text: "OtherDiagonalArrow",
            icon: <ArrowMinimizeRegular {...iconStyleProps} />,
        },
        {
            key: "DiagonalArrowHover",
            text: "DiagonalArrowHover",
            icon: <DiagonalArrowHover {...iconStyleProps} />,
        },
        {
            key: "ArrowDownHookLeft",
            text: "ArrowDownHookLeft",
            icon: (
                <ArrowHookDownLeftRegular
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            ),
        },
        {
            key: "ArrowDownHookLeftHover",
            text: "ArrowDownHookLeftHover",
            icon: (
                <ArrowDownHookLeftHover
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            ),
        },
        {
            key: "",
            text: "CheckmarkRegular",
            icon: (
                <CheckmarkRegular
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            ),
        },
        {
            key: "CheckmarkRegularHover",
            text: "CheckmarkRegularHover",
            icon: (
                <CheckmarkRegularHover
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            ),
        },
        {
            key: "Filtro",
            text: "Filtro",
            icon: (
                <FilterFilled
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            ),
        },
        {
            key: "AgregarPersona",
            text: "AgregarPersona",
            icon: (
                <AgregarPersona
                    {...iconStyleProps}
                    style={{ fontSize: 24 }}
                />
            ),
        },
        {
            key: "DescargaFiltro",
            text: "DescargaFiltro",
            icon: <DescargarFiltro {...iconStyleProps} style={{ fontSize: 24 }} />,
        },
    ];

    type ValoresUnion =
        | "Backlog"
        | "DescargarFooter"
        | "ReporteGeneral"
        | "EnviarFooter"
        | "RefrescarFooter"
        | "Refrescar"
        | "CancelarFooter"
        | "Calendario"
        | "Visualizar"
        | "Visitas"
        | "Tipos"
        | "Temporales"
        | "FlechasDerecha"
        | "FlechasIzquierda"
        | "Detalle"
        | "Agregar"
        | "Buscar"
        | "Eliminar"
        | "Editar"
        | "Info"
        | "EliminatDocumento"
        | "Historial"
        | "Documento"
        | "Documento2"
        | "DiagonalArrow"
        | "OtherDiagonalArrow"
        | "ArrowDownHookLeftHover"
        | "ReunionRegular"
        | "CheckmarkRegular"
        | "DescargaExcel"
        | "OjoRegular"
        | "GanntRegular"
        | "DownloadSubmit"
        | "Documentos"
        | "FinanzasRegular"
        | "IniciarRegular"
        | "UsuarioRegular"
        | "DocumentCheckmark"
        | "ConfiguracionRegular";

    const Icon = (
        textIcon: string | ValoresUnion,
        color?: string,
        fs = "24",
    ) => {
        const aux = iconos.filter((item) => item.text === textIcon);

        return (
            <>
                {aux[0]?.icon && color ? (
                    <>
                        {React.cloneElement(
                            <div className={styles.icon}>{aux[0].icon}</div>,
                            { style: { color, fontSize: fs } }
                        )}

                    </>
                ) : (
                    <>{aux[0]?.icon}</>
                )}

            </>
        );
    };

    return { Icon };
};
